import { VisitCountModel } from 'dibs-visit-tracking';
import { localStorage } from 'dibs-browser-storage';
import { MODAL_ID, CURRENT_VERSION } from './constants';
import collaborativePurchaseRule from './collabPurchaseRule';

/**
 * Resets the entire storage object if the version has changed, otherwise it handles
 * reseting the `viewedThisSession` field if necessary. It gets called right
 * away just below here because we can't guarantee that the rule for this will
 * get called by the queue at the beginning of a session.
 */
function init() {
    const modalStorage = localStorage.getItem(MODAL_ID);
    const visitTracking = new VisitCountModel();

    if (modalStorage) {
        if (modalStorage.version !== CURRENT_VERSION) {
            localStorage.setItem(MODAL_ID, {
                version: CURRENT_VERSION,
                viewedThisSession: false,
                totalViewCount: 0,
            });
        } else if (modalStorage.viewedThisSession && visitTracking.get('session') <= 1) {
            modalStorage.viewedThisSession = false;
            localStorage.setItem(MODAL_ID, modalStorage);
        }
    }
}

init(); // See docs for this above

export default {
    name: 'collaborativePurchasing',
    priority: 400,
    rule: collaborativePurchaseRule,
    action: () => () => {
        import(/* webpackChunkName: "collabPurchaseModalAction" */
        './collabPurchaseAction').then(({ default: action }) => action());
    },
};



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/collaborativePurchasing/index.js